<template>
    <div class="rt">
        <div class="rt-bottom" ref="Rtbottom" :style="{ width: '435px', height: '240px' }">
        </div>
    </div>
</template>

<script>


export default {
    name: 'template4.rightCent4',
    data() {
        return {
            //线路列表
            topMap: [],
            select: {},
            // 已选高速详情列表 name描述 val蓝色字体 unit白色字体
            cropsData: [
                { name: "救援力量", val: "ha", num1: '158', unit: "公顷" },
                { name: "应急物资", val: "kg", num1: '234', unit: "公斤" },
                { name: "避难场所", val: "kind", num1: '24', unit: "种" }
            ],
            numA: [160, 270, 304, 280, 220, 176, 160, 186, 252, 290, 302, 300]
        };
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
    methods: {
        TdrawLine() {
            var echarts = require('echarts');
            var TmyChart = echarts.init(this.$refs.Rtbottom);
            let xAxisData = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'];
            let data1 = [13, 10, 8, 6, 5, 6, 8, 11, 12, 11, 9, 5]
            let data2 = [5, 9, 11, 12, 11, 8, 6, 5, 6, 8, 12, 13]
            var Toption = {
                title: [{
                    text: '万元',
                    top: '20',
                    left: '8',
                    textStyle: {
                        color: "#B0B5BB",
                        fontSize: 12,
                    },
                },
                ],
                tooltip: {
                    trigger: 'axis'
                },
                legend: [
                    {    
                        itemStyle: {
                            color: '#3FE09D',
                        },
                        top: 20,
                        itemWidth: 16,
                        itemHeight: 3,
                        data: [
                            {
                                name: '回款金额',
                                icon: 'rect'
                            }
                        ],
                        right: "30%",
                        formatter: (name) => {
                            return '{a|' + name + '}'
                        },
                        textStyle: {
                            color: "#979AA0",
                            rich: {
                                a: {
                                    fontSize: '12',
                                    padding: [0, 0, 2, 0]
                                },
                            }
                        }
                    },
                    {
                        emphasis: {
                            show: true
                        },
                        itemStyle: {
                            color: '#6BC7F7',
                        },
                        top: 20,
                        itemWidth: 16,
                        itemHeight: 3,
                        data: [
                            {
                                name: '销售金额',
                                icon: 'rect'
                            }
                        ],
                        right: "10%",
                        formatter: (name) => {
                            return '{a|' + name + '}'
                        },
                        textStyle: {
                            color: "#979AA0",
                            rich: {
                                a: {
                                    fontSize: '12',
                                    padding: [0, 0, 2, 0]
                                },
                            }
                        }
                    }],
                grid: {
                    left: '14',
                    right: '4%',
                    bottom: '10%',
                    containLabel: true
                },
                xAxis: {
                    boundaryGap: false,
                    data: xAxisData,
                    axisLabel: {
                        margin: 22,
                        padding: [0, 20, 0, 20],
                        interval: 0,//文字全部显示

                        textStyle: {
                            color: '#bdc2cb' // 这里将 x 轴文本颜色设为灰白色
                        },
                    }
                },

                yAxis: {
                    // type: 'value',
                    min: 0, // 设置y轴刻度的最小值
                    max: 20,  // 设置y轴刻度的最大值
                    splitNumber: 3,  // 设置y轴刻度间隔个数
                    axisLabel: {
                        textStyle: {
                            color: '#bdc2cb' // 这里将 x 轴文本颜色设为灰白色
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dashed',
                            color: "rgba(231,241,251,.2)"
                        }
                    }

                },
                series: [
                    {
                        name: '回款金额',
                        type: 'line',
                        itemStyle: {
                            color: '#3FE09D',
                        },
                        areaStyle: {
                            opacity: 0.8,
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 0.4,
                                    color: '#1d676c'
                                },
                                {
                                    offset: 1,
                                    color: "rgba(0,0,0,0)"
                                }
                            ])
                        },
                        smooth: true,//线条原画
                        symbol: 'none',//线条点击
                        smooth: 0.5,
                        // emphasis: {
                        //   focus: 'series'
                        // },
                        data: data1,
                    },
                    {
                        itemStyle: {
                            color: '#6BC7F7',
                        },
                        name: '销售金额',
                        type: 'line',
                        // emphasis: {
                        //   focus: 'series'
                        // },
                        areaStyle: {
                            opacity: 0.8,
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 0.2,
                                    color: '#1980ac'
                                },
                                {
                                    offset: 1,
                                    color: "rgba(0,0,0,0)"
                                }
                            ]),
                        },
                        smooth: true,//线条原画
                        symbol: 'none',//线条点击
                        smooth: 0.5,
                        data: data2
                    },
                ]
            };
            Toption && TmyChart.setOption(Toption);
            setInterval(function () {
                TmyChart.clear();
                Toption && TmyChart.setOption(Toption);
            }, 5000)
        },
    },
    mounted() {
        this.$nextTick(() => {
            // this.drawLine(); //需要刷新的数据
            this.TdrawLine(); //需要刷新的数据
        });




    },
};
</script>

<style scoped lang="scss">
@font-face {
    font-family: "Benmo-Ziyu";
    src: url("../../assets/fonts/Benmo-Ziyu.woff2");
}

.rt {
    width: 435px;
    height: 240px;
    display: flex;
    padding: 10px 0;
    position: relative;
}

.rt-bottom {
    //减掉96px的高
    // padding: 10px 0;
    // margin-top: -10px;
    position: absolute;
    z-index: 5;
    box-sizing: border-box;
}
</style>